'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Item = require('./Item');

var _Item2 = _interopRequireDefault(_Item);

var _ItemButton = require('./ItemButton');

var _ItemButton2 = _interopRequireDefault(_ItemButton);

var _ItemLink = require('./ItemLink');

var _ItemLink2 = _interopRequireDefault(_ItemLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  border-bottom: solid ' + (0, _decisivUiUtils.px2rem)(2) + ' ' + theme.colors.base.chrome200 + ';\n  display: flex;\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var TabList = (0, _decisivUiUtils.buildStyledComponent)('TabList', _styledComponents2.default.ul, styles, {
  themePropTypes: themePropTypes
});

TabList.Icon = _Icon2.default;
TabList.Item = _Item2.default;
TabList.ItemButton = _ItemButton2.default;
TabList.ItemLink = _ItemLink2.default;

exports.default = TabList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/TabList/index.js
// module id = 442
// module chunks = 2